export const TYPE_COLOURS = {
    fighting: "#d72727",
    electric: "#f2da43",
    ice: "#37cac7",
    bug: "#8ab562",
    water: "#2f8fd0",
    psychic: "#e1808a",
    dark: "#4d5b61",
    fairy: "#df8ce1",
    grass: "#62b566",
    fire: "#f79648",
    poison: "#bf52d1",
    ghost: "#6055ad",
    rock: "#bab58e",
    ground: "#c57242",
    steel: "#568685",
    normal: "#919ea5",
    flying: "#79aecd",
    dragon: "#2c69aa",
}